import { useMemo } from 'react'

import { CounterData } from '@/api/models/counters/lib/counters.types'
import { ScreenSize } from '@/app/constants'
import { useCurrentBreakpoint } from '@/app/hooks/useCurrentBreakpoint'
import { cn } from '@/app/utils'

type Props = {
  countersList: CounterData[]
  areCountersAvailableNow: boolean
}

const CountersSummaryDescription = ({
  countersList,
  areCountersAvailableNow
}: Props) => {
  const { breakpoint } = useCurrentBreakpoint()
  const isTabletScreen = [ScreenSize.Lg, ScreenSize.Md].includes(breakpoint)

  const isAvailableCounterExist = useMemo(() => {
    return !(
      countersList?.length > 0 &&
      countersList.some(counter => !counter.readOnly)
    )
  }, [countersList])

  if (!countersList?.length) {
    return 'Нет данных о приборах учёта'
  }

  if (areCountersAvailableNow) {
    return (
      <span className={cn(isTabletScreen && 'whitespace-nowrap')}>
        Сейчас доступна передача показаний
      </span>
    )
  }

  if (isAvailableCounterExist) {
    return 'Показания прибора учёта передаёт Служба комфорта Sminex'
  }

  return 'Передача показаний приборов учёта сейчас недоступна'
}

export default CountersSummaryDescription
